import React from "react"
import { Redirect } from "react-router-dom"
import { YourBenefitGuide } from "#/pages/your-benefit-guide"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

export function YourBenefitGuideRoute(): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  if (isLoading) return <PageLoading />
  // Fail-closed on error: sending an unknown-program member to `/` keeps them
  // out of the enterprise guide and lands them on a page CarrotPlanRoute can
  // itself render for either program type. Better than an indefinite spinner.
  if (isError || !programFlags) return <Redirect to="/" />
  return programFlags.isConsumer ? <Redirect to="/" /> : <YourBenefitGuide />
}
